import { APICore } from './apiCore'

const api = new APICore()

function getLogs (params) {
  const baseUrl = '/logs'
  return api.get(baseUrl, params)
}

function getLog (id) {
  const baseUrl = `/logs/${id}`
  return api.get(baseUrl, {})
}

function addLog (params) {
  const baseUrl = '/logs'
  return api.create(baseUrl, params)
}

function updateLog (params) {
  const baseUrl = '/logs'
  return api.update(baseUrl, params)
}

function deleteLog (params) {
  const baseUrl = '/logs'
  return api.delete(baseUrl, params)
}
function getDistinctUsers () {
  const baseUrl = '/logs/by-user'
  return api.get(baseUrl, {})
}

export { getLogs, getLog, addLog, updateLog, deleteLog, getDistinctUsers }
